"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptLayout = void 0;
var react_1 = __importDefault(require("react"));
var PromptLayout = function (_a) {
    var heading = _a.heading, content = _a.content, button = _a.button;
    return (react_1.default.createElement("div", { className: "prompt-layout" },
        react_1.default.createElement("div", { className: "prompt-layout__header" },
            react_1.default.createElement("div", { className: "prompt-layout__heading" }, heading),
            react_1.default.createElement("div", { className: "prompt-layout__button" }, button)),
        react_1.default.createElement("div", { className: "prompt-layout__content" }, content)));
};
exports.PromptLayout = PromptLayout;
